import React__default from "react";
const TabsNavigationContext = React__default.createContext({
  setCurrentItem: (
    /* istanbul ignore next */
    () => null
  ),
  behaviour: "list"
});
export {
  TabsNavigationContext
};
